import React, { useState, useEffect } from 'react';
import { Home, Car, Plus, Edit2, Trash2, X, Upload, Lock, LogOut, Eye, ChevronLeft, ChevronRight, MapPin, Mail,Share2, Phone, User, MessageSquare, Clock, Building } from 'lucide-react';
import imageCompression from 'browser-image-compression';

const API_URL = 'https://karpiso.es/api';

export default function RealEstateApp() {

  const [isAdmin, setIsAdmin] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [loginData, setLoginData] = useState({ username: '', password: '' });
  const [activeTab, setActiveTab] = useState('pisos');
  const [items, setItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [showCookiePolicy, setShowCookiePolicy] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showLegalNotice, setShowLegalNotice] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [editingItem, setEditingItem] = useState(null);
  const [contactForm, setContactForm] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const getMapUrl = (ubicacion) => {
    const encodedLocation = encodeURIComponent(ubicacion);
    return `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodedLocation}&zoom=15`;
  };

  const getGoogleMapsLink = (ubicacion) => {
    const encodedLocation = encodeURIComponent(ubicacion);
    return `https://www.google.com/maps/search/?api=1&query=${encodedLocation}`;
  };
const shareWhatsApp = (item) => {
  const text = encodeURIComponent(
    `Te comparto este ${activeTab === 'pisos' ? 'piso' : 'coche'}:\n\n` +
    `${item.titulo}\n` +
    `${item.precio} €\n\n` +
    `${window.location.origin}`
  );

  window.open(`https://wa.me/?text=${text}`, '_blank');
};

const shareEmail = (item) => {
  const subject = encodeURIComponent(
    `Interesante ${activeTab === 'pisos' ? 'piso' : 'coche'}`
  );

  const body = encodeURIComponent(
    `Hola,\n\n` +
    `Te comparto este ${activeTab === 'pisos' ? 'piso' : 'coche'} que puede interesarte:\n\n` +
    `${item.titulo}\n` +
    `${item.descripcion}\n` +
    `${item.precio} €\n\n` +
    `Ver más detalles en:\n${window.location.origin}`
  );

  window.location.href = `mailto:?subject=${subject}&body=${body}`;
};

  const [formData, setFormData] = useState({
    titulo: '',
    descripcion: '',
    precio: '',
    ubicacion: '',
    metros: '',
    habitaciones: '',
    banos: '',
    marca: '',
    modelo: '',
    ano: '',
    kilometros: '',
    imagenes: [],
    estado: 'disponible' // disponible, reservado, vendido
  });
const comprimirImagen = async (file) => {
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true
  };
  return await imageCompression(file, options);
};
  useEffect(() => {
    const adminSession = localStorage.getItem('adminSession');
    if (adminSession) {
      setIsAdmin(true);
    }
    
    // Verificar si ya aceptó las cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setShowCookieBanner(true);
    }
    
    fetchItems();
  }, [activeTab]);

  const fetchItems = async () => {
    try {
      const response = await fetch(`${API_URL}/${activeTab}`);
      const data = await response.json();
      setItems(data);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  const handleLogin = async () => {
    try {
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginData)
      });
      
      const data = await response.json();
      
      if (data.success) {
        setIsAdmin(true);
        setShowLogin(false);
        localStorage.setItem('adminSession', 'true');
        setLoginData({ username: '', password: '' });
      } else {
        alert('Credenciales incorrectas');
      }
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      alert('Error al iniciar sesión');
    }
  };

  const handleLogout = () => {
    setIsAdmin(false);
    localStorage.removeItem('adminSession');
  };
const addWatermark = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      const img = new Image();
      img.src = reader.result;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = img.width;
        canvas.height = img.height;

        // Dibuja la imagen original
        ctx.drawImage(img, 0, 0);

        // Configuración del texto
        const text = 'www.karpiso.es';
        const fontSize = Math.max(canvas.width, canvas.height) / 18;

        ctx.globalAlpha = 0.25;
        ctx.fillStyle = '#ffffff';
        ctx.font = `bold ${fontSize}px Arial`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        // Mover origen al centro y rotar
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(-Math.PI / 4);

        // Dibuja el texto
        ctx.fillText(text, 0, 0);

        // Vuelve al estado original
        ctx.rotate(Math.PI / 4);
        ctx.translate(-canvas.width / 2, -canvas.height / 2);

        // Convertir a archivo
        canvas.toBlob((blob) => {
          const watermarkedFile = new File([blob], file.name, {
            type: file.type,
            lastModified: Date.now(),
          });
          resolve(watermarkedFile);
        }, file.type);
      };
    };
  });
};

 const handleImageUpload = async (e) => {
  const files = Array.from(e.target.files);

  const watermarkedImages = await Promise.all(
    files.map((file) => addWatermark(file))
  );

  setFormData({ ...formData, imagenes: [...formData.imagenes, ...watermarkedImages] });
};


  const handleSubmit = async () => {
    // Validaciones
    if (!formData.titulo.trim()) {
      alert('El título es obligatorio');
      return;
    }
    if (!formData.descripcion.trim()) {
      alert('La descripción es obligatoria');
      return;
    }
    if (!formData.precio || formData.precio <= 0) {
      alert('El precio es obligatorio y debe ser mayor a 0');
      return;
    }

    if (activeTab === 'pisos') {
      if (!formData.ubicacion.trim()) {
        alert('La ubicación es obligatoria');
        return;
      }
      if (!formData.metros || formData.metros <= 0) {
        alert('Los metros cuadrados son obligatorios y deben ser mayor a 0');
        return;
      }
      if (!formData.habitaciones || formData.habitaciones <= 0) {
        alert('El número de habitaciones es obligatorio y debe ser mayor a 0');
        return;
      }
      if (!formData.banos || formData.banos <= 0) {
        alert('El número de baños es obligatorio y debe ser mayor a 0');
        return;
      }
    } else {
      if (!formData.marca.trim()) {
        alert('La marca es obligatoria');
        return;
      }
      if (!formData.modelo.trim()) {
        alert('El modelo es obligatorio');
        return;
      }
      if (!formData.ano || formData.ano <= 1900 || formData.ano > new Date().getFullYear() + 1) {
        alert(`El año es obligatorio y debe estar entre 1900 y ${new Date().getFullYear() + 1}`);
        return;
      }
      if (!formData.kilometros || formData.kilometros < 0) {
        alert('Los kilómetros son obligatorios y no pueden ser negativos');
        return;
      }
    }

    if (!formData.imagenes || formData.imagenes.length === 0) {
      alert('Debe subir al menos una imagen');
      return;
    }

    const endpoint = editingItem 
      ? `${API_URL}/${activeTab}/${editingItem.id}`
      : `${API_URL}/${activeTab}`;
    const method = editingItem ? 'PUT' : 'POST';

    try {
	const data = new FormData();
data.append('datos', JSON.stringify(formData));
formData.imagenes.forEach((imagen) => {
    data.append('imagenes', imagen); // imagen es un File object
  });
      await fetch(endpoint, {
        method,
        //headers: { 'Content-Type': 'application/json' },
        body: data
      });
      fetchItems();
      closeModal();
    } catch (error) {
      console.error('Error saving item:', error);
      alert('Error al guardar. Por favor intenta de nuevo.');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este elemento?')) {
      try {
        await fetch(`${API_URL}/${activeTab}/${id}`, { method: 'DELETE' });
        fetchItems();
      } catch (error) {
        console.error('Error deleting item:', error);
      }
    }
  };

  const handleEstadoChange = async (id, nuevoEstado) => {
    try {
      const item = items.find(i => i.id === id);
      if (!item) return;

      await fetch(`${API_URL}/${activeTab}/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...item, estado: nuevoEstado })
      });
      fetchItems();
    } catch (error) {
      console.error('Error updating estado:', error);
    }
  };
const getImageSrc = (img: string | File) => {
  if (img instanceof File) {
    return URL.createObjectURL(img);
  }
  return img;
};
  const openModal = (item = null) => {
    if (item) {
      setEditingItem(item);
      setFormData(item);
    } else {
      setEditingItem(null);
      setFormData({
        titulo: '',
        descripcion: '',
        precio: '',
        ubicacion: '',
        metros: '',
        habitaciones: '',
        banos: '',
        marca: '',
        modelo: '',
        ano: '',
        kilometros: '',
        imagenes: [],
        estado: 'disponible'
      });
    }
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingItem(null);
  };

  const openDetailModal = (item) => {
    setSelectedItem(item);
    setCurrentImageIndex(0);
    setShowDetailModal(true);
  };

  const closeDetailModal = () => {
    setShowDetailModal(false);
    setSelectedItem(null);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    if (selectedItem && selectedItem.imagenes.length > 0) {
      setCurrentImageIndex((prev) => (prev + 1) % selectedItem.imagenes.length);
    }
  };

  const prevImage = () => {
    if (selectedItem && selectedItem.imagenes.length > 0) {
      setCurrentImageIndex((prev) => (prev - 1 + selectedItem.imagenes.length) % selectedItem.imagenes.length);
    }
  };

const formatPrecio = (precio) => {
  return new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(precio);
};
  const removeImage = (index) => {
    const newImages = formData.imagenes.filter((_, i) => i == index);
const newImagesA = formData.imagenes.filter((_, i) => i !== index);
    if (!formData.imagenesToRemove) formData.imagenesToRemove =[];
    let ary = [...formData.imagenesToRemove];
	ary.push(newImages[0]);
    setFormData({ ...formData, imagenesToRemove: ary,imagenes:newImagesA });
  };

  const openContactModal = (item = null) => {
    setSelectedItem(item);
    setContactForm({
      nombre: '',
      email: '',
      telefono: '',
      mensaje: item ? `Hola, estoy interesado en: ${item.titulo}` : ''
    });
    setShowContactModal(true);
  };

  const closeContactModal = () => {
    setShowContactModal(false);
    setSelectedItem(null);
    setContactForm({
      nombre: '',
      email: '',
      telefono: '',
      mensaje: ''
    });
  };

  const handleContactSubmit = async () => {
    // Validaciones
    if (!contactForm.nombre.trim()) {
      alert('El nombre es obligatorio');
      return;
    }
    if (!contactForm.email.trim() || !contactForm.email.includes('@')) {
      alert('El email es obligatorio y debe ser válido');
      return;
    }
    if (!contactForm.mensaje.trim()) {
      alert('El mensaje es obligatorio');
      return;
    }

    try {
      const response = await fetch(`${API_URL}/contacto`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...contactForm,
          itemId: selectedItem?.id,
          itemTitulo: selectedItem?.titulo,
          itemTipo: activeTab
        })
      });

      const data = await response.json();

      if (data.success) {
        alert('¡Mensaje enviado correctamente! Te contactaremos pronto.');
        closeContactModal();
      } else {
        alert('Error al enviar el mensaje. Por favor intenta de nuevo.');
      }
    } catch (error) {
      console.error('Error sending contact:', error);
      alert('Error al enviar el mensaje. Por favor intenta de nuevo.');
    }
  };

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowCookieBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setShowCookieBanner(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <nav className="bg-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        <svg version="1.1" viewBox="0 0 2048 704" width="150" height="80" xmlns="http://www.w3.org/2000/svg">
<path transform="translate(0)" d="m0 0h2048v704h-2048z" fill="#FDFDFD"/>
<path transform="translate(796,14)" d="m0 0 13 2 704 154 164 36 3 1-1-13-1-73-24-1-1-1v-50h191v50h-16l-8-1v120l12 2 211 46 1 3-1 7-53 1h-33v396l-23 1h-1903v-43h1887v-353l-13-2-521-100-551-106-19 14-18 14-20 15-18 14-16 12-13 10-76 58-16 12-13 10-34 26-24 18-19 1h-49l-22-1-3-9 15-13 11-9 14-12 11-9 26-22 11-9 13-11 11-9 14-12 11-9 13-11 11-9 14-12 11-9 26-22 11-9 26-22 11-9 13-11 11-9 14-12 14-11z" fill="#562776"/>
<path transform="translate(1738,316)" d="m0 0h13l21 2 17 4 12 4 18 8 15 9 14 11 12 11 11 13 10 15 8 15 7 19 4 15 3 26v12l-2 19-4 18-5 15-9 19-12 18-11 13-10 10-14 11-15 9-19 9-20 6-15 3-9 1h-28l-18-3-21-6-16-7-16-9-11-8-10-9-8-7-13-16-8-13-9-17-7-20-4-19-1-8v-30l3-18 5-19 8-19 9-16 10-13 12-13 7-7 13-10 15-9 19-9 24-7z" fill="#DF0086"/>
<path transform="translate(39,231)" d="m0 0h114l1 66 1 123 11-13 18-22 28-34 9-11 11-13 8-10 11-13 9-11 8-10 16-1 41-1h32v8l-11 6-8 8-8 10-9 11-26 32-9 11-13 16-14 17-22 28-4 5-1 3 9 1 39 9 36 10 23 8 21 9 14 8 10 9 4 8-1 16-5 37-5 33-4 10-6 8-8 8-15 8-17 5-26 4-25 2 9-19 3-9 3-17-1-17-4-15-7-14-11-12-10-7-12-5-15-3h-22l-21 4-32 11h-2v109l-21 1h-96l-1-1v-56l1-1 24-3 8-3 3-5 1-275-24-1-9-1-1-1z" fill="#DE0086"/>
<path transform="translate(698,328)" d="m0 0h146l18 2 17 4 16 6 15 9 7 6 9 12 6 13 4 16 1 8v22l-3 15-5 13-5 9-8 10-10 10-14 10h-2l7 8 7 9 14 29 16 36 5 10v2l24 1 4 1v46l-1 1h-119v-46l21-3 1-4-14-30-12-25-6-7-5-2-45-1v69l27 1 2 1v46l-18 1h-101l-2-1v-44l1-1 18-2 8-3 1-209h-11l-14-1z" fill="#DF0086"/>
<path transform="translate(979,328)" d="m0 0h150l21 3 21 7 15 8 11 9 8 9 9 15 5 15 3 17v30l-4 20-7 16-7 11-9 10-10 9-11 7-14 7-16 5-25 5-9 1h-42v55h16l26 1 1 1v46l-16 1h-118l-1-1v-33l1-12 23-3 3-1 1-210-25-1z" fill="#DF0086"/>
<path transform="translate(458,328)" d="m0 0h111l4 10 20 57 17 48 19 54 17 48 14 39 1 2 24 2 3 1v47h-124l-1-1v-45l21-2 7-2-3-12-6-17h-97l-5 12-6 18 21 1 4 1v46l-22 1h-90l-1-1v-45l19-2 6-3 5-11 19-56 15-43 21-61 12-35 1-4-17-1-8-1-1-1z" fill="#DF0086"/>
<path transform="translate(1485,322)" d="m0 0h14l25 2 23 5 24 8 10 5 1 22v38l-1 15-39 3h-15l-1-36-5-5-10-2h-27l-13 3-10 5-6 7-3 7-1 5v10l3 9 5 8 9 6 12 5 36 12 18 7 17 9 17 12 10 10 7 11 5 12 3 12 1 10v17l-3 19-6 16-8 12-9 10-11 9-15 9-19 7-25 5-11 1h-11l-26-2-23-4-21-6-20-8-1-3v-63l1-13 54-4 1 38 3 3 8 3 14 2h20l17-3 13-7 6-8 3-7 1-5v-13l-4-11-5-5-5-4-17-8-35-11-15-5-21-10-14-10-8-7-9-13-6-15-3-20v-16l3-19 5-14 8-13 11-12 10-8 16-9 18-6 16-3z" fill="#DF0086"/>
<path transform="translate(1245,328)" d="m0 0h117v44l-2 1-17 2-7 2-1 3-1 207 25 1 1 1v46l-15 1h-102l-1-1v-40l1-5 18-2 8-2 1-210h-11l-14-1z" fill="#DF0086"/>
<path transform="translate(39,231)" d="m0 0h114l1 66 1 123 11-13 18-22 28-34 9-11 11-13 8-10 11-13 9-11 8-10 16-1 41-1h32v8l-11 6-8 8-8 10-9 11-26 32-9 11-13 16-14 17-22 28-4 5-1 3 9 1 39 9 36 10 23 8 21 9 14 8 10 9 4 8-1 16-5 37-5 33-4 10-6 8-8 8-15 8-17 5-26 4-25 2 9-19 3-9 3-17-1-17-4-15-7-14-11-12-10-7-12-5-15-3h-22l-21 4-32 11h-2v109l-21 1h-96l-1-1v-56l1-1 24-3 8-3 3-5 1-275-24-1-9-1-1-1zm46 7-32 1-4 1-1 2v39l2 1 30 2 1 1v280l-2 9-5 6-7 3-19 3-3 1v39h97l3-1 1-105 28-10 22-6 11-2h26l18 4 12 5 10 7 7 6 10 14 6 14 3 11 1 8v17l-3 16-4 11v3h9l23-4 17-5 9-5 9-7 7-14 3-11 2-17v-5l-13-3-9-5-8-8-8-14-2-7 8 16 11 12 11 6 10 2 2-8 4-33-38-1 32-1 7-1-1-7-4-6-11-8-21-10-30-10-33-9-60-13h-4l3-5 13-16 9-12 13-16 9-11 13-16 9-11 13-16 9-11 13-16 11-13 5-7v-2h-18l-30 1-13 1-4 2-11 14-14 17-9 11-11 13-8 10-14 17-9 11-11 13-9 11-11 13-9 11-4 1-4-2v-178l-1-12-4-4-4-1-22-1z" fill="#6B298B"/>
<path transform="translate(1738,316)" d="m0 0h13l21 2 17 4 12 4 18 8 15 9 14 11 12 11 11 13 10 15 8 15 7 19 4 15 3 26v12l-2 19-4 18-5 15-9 19-12 18-11 13-10 10-14 11-15 9-19 9-20 6-15 3-9 1h-28l-18-3-21-6-16-7-16-9-11-8-10-9-8-7-13-16-8-13-9-17-7-20-4-19-1-8v-30l3-18 5-19 8-19 9-16 10-13 12-13 7-7 13-10 15-9 19-9 24-7zm-7 19-18 3-21 7-16 8-14 9-13 11-9 9-10 13-8 14-7 15-5 16-3 16-1 11v15l3 21 6 20 11 23 8 11 9 11 10 10 17 13 16 9 18 7 23 5 8 1h21l19-3 20-6 21-10 14-10 10-9 6-5 9-11 8-11 11-21 6-19 3-16v-33l-3-19-7-21-8-16-8-12-9-11-12-12-15-11-14-8-17-7-17-5-14-2z" fill="#6A2A8C"/>
<path transform="translate(1740,403)" d="m0 0h11l16 3 14 6 12 9 8 8 7 11 5 11 3 12v21l-4 15-6 12-8 10-8 8-13 8-13 5-13 2h-11l-16-3-12-5-10-7-10-9-7-10-6-12-3-11-1-7v-14l3-14 5-12 10-14 10-9 10-6 8-4 12-3z" fill="#FDFCFC"/>
<path transform="translate(833,89)" d="m0 0 547 105 530 102 8 2v353h-28v-1h12l-1-85v-58l-1-8 2-19v-12l-2-25 1-5v-134l-27-5-89-17-682-131-244-47-32-6-2-3z" fill="#D1D2D3"/>
<path transform="translate(212,514)" d="m0 0h21l17 5 11 6 10 9 9 10 7 15 2 9v21l-3 11-7 14-9 10-8 7-10 6-14 5-5 1h-21l-12-3-10-4-13-9-8-8-8-13-4-11-2-10v-12l2-12 5-12 9-13 11-10 16-8z" fill="#242125"/>
<path transform="translate(1485,322)" d="m0 0h14l25 2 23 5 24 8 10 5 1 22v38l-1 15-39 3h-15l-1-36-5-5-10-2h-27l-13 3-10 5-6 7-3 7-1 5v10l3 9 5 8 9 6 12 5 36 12 18 7 17 9 17 12 10 10 7 11 5 12 3 12 1 10v17l-3 19-6 16-8 12-9 10-11 9-15 9-19 7-25 5-11 1h-11l-26-2-23-4-21-6-20-8-1-3v-63l1-13 54-4 1 38 3 3 8 3 14 2h20l17-3 13-7 6-8 3-7 1-5v-13l-4-11-5-5-5-4-17-8-35-11-15-5-21-10-14-10-8-7-9-13-6-15-3-20v-16l3-19 5-14 8-13 11-12 10-8 16-9 18-6 16-3zm-4 9-20 3-16 5-16 8-10 7-11 11-8 14-5 14-2 12v20l3 15 5 13 7 10 9 9 15 10 15 7 30 10 19 6 15 6 12 7 7 9 4 9 1 4v14l-3 13-6 11-8 7-11 5-13 3-9 1h-20l-14-2-12-4-5-5-2-6-1-26-1-2h-14l-21 2-1 1v62l3 3 19 7 20 5 21 3h38l19-3 16-5 16-8 14-10 8-8 9-14 5-14 2-11v-27l-4-18-8-15-11-11-18-12-16-8-25-9-30-10-14-7-6-5-6-9-4-10-1-12 4-15 6-9 7-6 12-5 14-3h26l15 3 6 4 3 5 1 7 1 24 22-1 14-2v-61l-30-10-20-4-18-2z" fill="#6C298C"/>
<path transform="translate(698,328)" d="m0 0h146l18 2 17 4 16 6 15 9 7 6 9 12 6 13 4 16 1 8v22l-3 15-5 13-5 9-8 10-10 10-14 10h-2l7 8 7 9 14 29 16 36 5 10v2l24 1 4 1v46l-1 1h-119v-46l21-3 1-4-14-30-12-25-6-7-5-2-45-1v69l27 1 2 1v46l-18 1h-101l-2-1v-44l1-1 18-2 8-3 1-209h-11l-14-1zm52 7-38 1-5 2-1 2v26l7 1 19 1-1 216-3 7-3 3-20 5-1 6v21l1 1h78l20-1 4-4v-21l-4-4-18-2-4-2-1-4-1-25v-54h53l11 4 7 8 8 15 13 28 7 16v7l-3 5-6 3-13 3-1 1v26l1 1h75l25-1 1-1v-28l-1-1-21-1-3-3-11-23-15-33-10-21-7-9-11-8-1-7 19-12 12-11 9-11 6-12 3-10 1-7v-27l-3-15-5-12-6-9-4-5-13-9-16-7-14-4-20-3-36-2z" fill="#6C298C"/>
<path transform="translate(1738,379)" d="m0 0h11l20 3 15 5 13 7 12 9 8 8 10 14 7 15 4 13 2 12v17l-3 16-6 16-7 13-9 11-9 9-13 9-15 7-16 4-6 1h-22l-16-3-15-6-15-9-13-12-9-11-7-12-6-17-3-19v-13l3-16 6-16 8-15 9-11 10-9 14-9 14-6 16-4zm2 24-15 3-10 4-9 5-10 8-7 8-7 11-5 13-2 11v14l3 15 5 12 7 10 9 10 10 7 12 6 11 3 8 1h11l13-2 15-6 12-8 10-10 7-11 4-8 4-15v-21l-4-15-8-15-11-12-12-9-14-6-16-3z" fill="#6C298C"/>
<path transform="translate(458,328)" d="m0 0h111l4 10 20 57 17 48 19 54 17 48 14 39 1 2 24 2 3 1v47h-124l-1-1v-45l21-2 7-2-3-12-6-17h-97l-5 12-6 18 21 1 4 1v46l-22 1h-90l-1-1v-45l19-2 6-3 5-11 19-56 15-43 21-61 12-35 1-4-17-1-8-1-1-1zm15 8-6 2v26l1 1 19 2h10l-18 52-15 43-15 44-15 43-12 34-6 10-6 3-14 3-1 1v26l1 1h67l25-1 1-1v-28l-1-1-26-1 3-10 12-35 1-2h110l4 9 8 25v6l-3 5-7 3-18 3v27l1 1h79l25-1 1-1v-28l-1-1-21-1-3-3-13-36-17-48-19-54-17-48-13-37-11-31-1-2z" fill="#6C298C"/>
<path transform="translate(242,448)" d="m0 0 10 1 30 7 30 8 30 10 23 11 10 8 4 7v5l-7 1-32 1 38 1-4 33-2 8-12-3-10-6-7-7-8-13-4-9 5 13 7 11 8 8 11 5 10 2v8l-3 19-5 13-5 6-12 6-15 3-23 3h-4l2-12 2-10v-22l-5-21-8-16-8-11-9-8-13-8-15-6-11-3v-3l1-9 1-5h21l26 3 24 5 38 11-19-9-22-8-29-8-31-6-13-3 3-9z" fill="#F08FB7"/>
<path transform="translate(979,328)" d="m0 0h150l21 3 21 7 15 8 11 9 8 9 9 15 5 15 3 17v30l-4 20-7 16-7 11-9 10-10 9-11 7-14 7-16 5-25 5-9 1h-42v55h16l26 1 1 1v46l-16 1h-118l-1-1v-33l1-12 23-3 3-1 1-210-25-1zm47 7-33 1-5 2-1 6v21l1 1 7 1 17 1v216l-3 7-6 4-17 4-1 4v23l1 1h93l19-1 4-4v-22l-3-3-5-1-28-1-4-1-2-11v-54l1-6h27l24-1 24-3 20-6 14-7 14-10 11-11 9-14 6-16 3-16v-26l-4-20-5-13-7-11-9-10-10-7-14-7-16-5-18-3-11-1-25-1z" fill="#6C298C"/>
<path transform="translate(1082,380)" d="m0 0 30 1 17 3 12 5 7 5 5 9 3 9 1 8v17l-3 13-5 9-4 5-9 6-12 5-8 2-9 1h-39v-97z" fill="#FDFCFD"/>
<path transform="translate(1245,328)" d="m0 0h117v44l-2 1-17 2-7 2-1 3-1 207 25 1 1 1v46l-15 1h-102l-1-1v-40l1-5 18-2 8-2 1-210h-11l-14-1zm12 8-3 1-1 3v18l1 8 7 1 17 1v202l-1 17-4 6-8 3-14 3v28h78l19-1 2-1 1-6v-15l-2-6-20-4-2-4-1-19v-189l3-10 6-4 17-4 1-2v-22l-1-4z" fill="#6A298C"/>
<path transform="translate(800,380)" d="m0 0h20l24 2 13 4 8 6 6 12 1 5v23l-4 13-6 8-7 6-12 5-12 2h-44v-85z" fill="#FDFDFD"/>
<path transform="translate(23,245)" d="m0 0h16l1 44 27 2 6 1v275l-3 5-5 3-9 1v-279h-13l-20-2-1-49z" fill="#D1D3D3"/>
<path transform="translate(216,540)" d="m0 0h14l13 4 10 7 6 7 5 10 1 5v14l-3 10-6 9-7 7-12 6-10 2h-8l-12-3-8-4-9-8-6-10-3-10v-12l3-10 6-9 8-8 10-5z" fill="#F8F5F6"/>
<path transform="translate(1244,327)" d="m0 0h118v1h-117v47h14l11 1v207l-1 3-8 3h-8v-207l-21-1-4-1v-38h16z" fill="#D2CFD2"/>
<path transform="translate(1402,355)" d="m0 0 3 1-8 11-7 14-4 17-1 9v16l3 20 7 17 10 13 10 8 13 8 19 9 45 14 16 7 8 5 5 5 4 6 2 7v13l-3 10-6 9-5 4-7 3 1-7 2-8v-16l-3-9-6-8-10-7-16-7-32-10-18-6-17-8-12-8-10-9-8-11-6-13-3-14v-31l4-16 8-16 8-10 8-8z" fill="#D2D1D3"/>
<path transform="translate(1741,394)" d="m0 0h9l15 2 16 6 13 8 10 9 8 10 8 15 4 14 1 6v19l-3 14-6 15-9 13-10 10-14 9-12 5-11 3-7 1h-16l-17-4-12-5-11-7-11-10-10-14-6-13-4-18v-16l3-15 5-13 9-14 9-10 13-9 12-6 14-4zm-1 9-15 3-10 4-9 5-10 8-7 8-7 11-5 13-2 11v14l3 15 5 12 7 10 9 10 10 7 12 6 11 3 8 1h11l13-2 15-6 12-8 10-10 7-11 4-8 4-15v-21l-4-15-8-15-11-12-12-9-14-6-16-3z" fill="#6A298B"/>
<path transform="translate(697,328)" d="m0 0h1v47h14l11 1v209l-5 3-4 1h-8v-206l-1-1-24-2v-38h16z" fill="#D1D2D3"/>
<path transform="translate(978,341)" d="m0 0h1v34h15l10 1v208l-4 4-5 1h-8v-206l-1-1-19-1-5-1v-38z" fill="#D1D3D3"/>
<path transform="translate(209,510)" d="m0 0h22l15 3 12 5 10 7 9 9 8 13 5 15 2 14-1 16-4 16-10 20 29-2-2 2-24 4-16 1v-2h2l2-6 8-8 8-14 3-9 1-5v-21l-3-12-7-13-9-10-8-7-14-7-14-4h-21l-14 4-16 8-11 10-9 14-4 10-2 12v12l4 16 6 12 7 9 9 8 10 6 14 5 6 1 17 1-3 3-7 3 1079 1v1h-1267v-1l151-1-14-6-12-8h-2v-109l28-10 15-4z" fill="#D7C6CE"/>
<path transform="translate(533,397)" d="m0 0h2l18 57 16 51v1h-71l2-9 32-97z" fill="#FDFBFC"/>
<path transform="translate(442,342)" d="m0 0h16l1 30 25 3-1 7-19 56-15 43-21 61-13 37-5 8-5 2h-7l12-36 22-64 19-55 17-49 1-4-15-1-12-2z" fill="#D2D1D3"/>
<path transform="translate(1061,372)" d="m0 0h50l19 3 16 6 8 6 6 9 5 15 1 7v20l-4 16-6 11-10 10-14 7-11 3-17 2h-36l-7-1-1-1-1-11v-94zm21 8-14 1v97h39l14-2 13-5 8-5 5-5 4-5 4-9 2-10v-17l-2-12-4-9-5-7-9-5-11-4-14-2z" fill="#6C298C"/>
<path transform="translate(532,377)" d="m0 0 6 1 12 36 24 76 7 22-1 3h-94l-1-2 12-36 21-64 11-33zm1 20-21 63-14 43v3h71l-10-33-22-69-2-7z" fill="#6C298C"/>
<path transform="translate(1737,388)" d="m0 0h16l16 3 13 5 11 6 11 9 10 11 8 13 6 15 2 9 1 9v12l-3 17-5 13-6 11-8 10-9 9-14 9-13 6-17 4h-22l-19-5-16-8-10-8-6-5-10-13-8-16-4-14-1-6v-22l5-19 7-14 9-12 10-10 14-9 11-5 14-4zm4 6-15 2-16 6-14 9-10 9-10 14-5 11-4 14-1 7v16l4 18 8 16 10 13 9 8 13 8 13 5 14 3h16l15-3 13-5 12-7 12-11 8-10 7-14 4-13 1-7v-19l-3-14-5-12-7-12-11-12-11-8-14-7-14-4-10-1z" fill="#F6ECF0"/>
<path transform="translate(780,372)" d="m0 0h56l20 4 12 6 7 8 4 10 2 9v23l-4 15-6 10-8 8-15 7-9 2-9 1h-21l-28-1-2-7-1-11v-81zm20 8-13 1v85h44l12-2 12-5 10-9 5-10 2-8v-23l-3-10-5-8-9-6-11-3-24-2z" fill="#6B298C"/>
<path transform="translate(1611,387)" d="m0 0h2l-2 5-9 17-7 19-5 23-1 8v30l3 18 4 16 8 19 10 18 9 12 11 13 10 9 12 9 15 9 17 8 20 6 14 3 8 1v1h-23l-21-4-21-7-19-10-14-10-10-9-12-12-11-15-4-6-2 4v-25l-2-16-6-16-6-10-4-6 1-20 4-22 5-16 7-16 13-21z" fill="#D3CFD2"/>
<path transform="translate(30,651)" d="m0 0h1v43h1889v1l-1881 1-3 2h-22v-32l1-1h13l2 1z" fill="#D1D2D3"/>
<path transform="translate(1652,68)" d="m0 0h189v1h-188l1 50 24 1 1 1 1 86-12-2-5-2-1-30v-48h-25l-1-1v-41h16z" fill="#D2D1D2"/>
<path transform="translate(1377,556)" d="m0 0h8l1 66 33 11 24 5 16 2 17 1h17l-4 2-19 3h-30l-26-3-20-5-25-9-1-1v-34l1-37z" fill="#D1D2D3"/>
<path transform="translate(533,397)" d="m0 0h2l18 57 16 51v1h-71l1-3v2l49-1-14-45-9-28v-2h-2l3-11z" fill="#D2D1D3"/>
<path transform="translate(1082,380)" d="m0 0 30 1 17 3 12 5 7 5 5 9 3 9 1 8v17l-3 13-5 9-4 5-9 6-4 1 6-17 1-6v-19l-3-16-5-10-8-7-12-5-13-3-16-2h-14v-5z" fill="#D2D1D2"/>
<path transform="translate(787,518)" d="m0 0h45l6 3 6 7 17 35 9 20-1 4-5 2-13 1-7-17-17-36-6-8-7-4-4-1-16-1-6-1v23h-1z" fill="#D2D1D2"/>
<path transform="translate(800,380)" d="m0 0h20l24 2 13 4 8 6 6 12 1 5v23l-4 13-6 8-7 6-4 2-3-1 5-12 1-5v-25l-3-12-6-8-5-4-9-4-16-3-26-2-1 19h-1v-23z" fill="#D2D0D2"/>
<path transform="translate(209,510)" d="m0 0h22l15 3 12 5 10 7 9 9 8 13 5 15 2 14-1 16-4 16-10 20 29-2-2 2-24 4-16 1v-2h2l2-6 8-8 8-14 3-9 1-5v-21l-3-12-7-13-9-10-8-7-14-7-14-4h-21l-14 4-16 8-6 5-10 4-10 7h-1l-1-6v-11l28-10 15-4z" fill="#D7CCD1"/>
<path transform="translate(332,508)" d="m0 0h46l-4 33-2 8-12-3-10-6-7-7-8-13-3-7z" fill="#FCF9FA"/>
<path transform="translate(1326,377)" d="m0 0h1l1 15 3 13v14l-1 8v27l1 32v62l1 12v25l1 4 9 2h9l3 1 1 2v10l-3 19-1 3-3-1h2v-21l-1-5-20-4-3-5-1-19v-189z" fill="#921791"/>
<path transform="translate(1484,376)" d="m0 0h27l10 2 5 4 1 2v36l15-1h14l-1 4-28 2h-17l-1-33-3-5-11-4-21-2-3-2z" fill="#D2D0D2"/>
<path transform="translate(485,556)" d="m0 0h97l4 9 6 19-1 3-7 2h-11l-8-25v-2l-80-1-1-4z" fill="#D5CFD3"/>
<path transform="translate(35,590)" d="m0 0h1l1 45 91 1v1l-67 2-9 1h-32v-48z" fill="#D1D3D3"/>
<path transform="translate(385,590)" d="m0 0h1l1 45 85 1v1l-48 1 28 1v1l-24 1h-58l-1-1v-35l7-2h9z" fill="#D1D3D3"/>
<path transform="translate(562,590)" d="m0 0h1l1 45 104 1v1l-75 1 43 1v1l-45 1h-44l-1-1v-36l16-1z" fill="#D1D3D3"/>
<path transform="translate(141,234)" d="m0 0h7l2 2 1 10 1 15-1 17-2 52-2 37-1 49h-1v-160l-1-12-1-3-6-1-22-1h-30l-36 1-1 41h-1v-42l6-2 56-1z" fill="#921791"/>
<path transform="translate(846,591)" d="m0 0h1v45h93v1l-61 1 37 1v1l-61 1h-24l-1-1v-36l7-1h9z" fill="#D2D0D2"/>
<path transform="translate(250,297)" d="m0 0h7l-6 8-13 15-8 10-11 13-8 10-9 11-28 34-11 13-8 10h-1v-9h2l2-4 11-13 13-16 18-22 14-17 9-11 14-17 9-11z" fill="#D3CED1"/>
<path transform="translate(1234,603)" d="m0 0h8l1 32 90 1v1l-56 1 17 1v1l-38 1h-30v-37z" fill="#D1D3D3"/>
<path transform="translate(1061,523)" d="m0 0 4 1h-2l-1 7 2 10 2 3v45l1 3 21-1h15l4 2 1 10v13l-3 9-3 3-23-1v-1l19-1 3-3v-22l-2-2-5-1-28-1-5-2-2-11v-54z" fill="#921791"/>
<path transform="translate(779,510)" d="m0 0 2 1-1 7 4 10 1 48v15l25 1 2 5 1 13-1 11-2 4-3 2h-24v-1l20-1 3-3v-21l-3-3-18-2-5-3-1-4-1-25v-52z" fill="#921791"/>
<path transform="translate(780,372)" d="m0 0 4 1-3 1-1 6 4 11 1 8v55l-1 12-2 7h38l10 1v1h-21l-28-1-2-7-1-11v-81z" fill="#921791"/>
<path transform="translate(967,602)" d="m0 0 9 1 1 32 107 1v1l-77 1 28 1v1h-72l-2-1 1-3 4-1z" fill="#D1D3D3"/>
<path transform="translate(193,513)" d="m0 0h8l7 1-1 2-14 5-12 7-5 4-10 4-10 7h-1l-1-6v-11l28-10z" fill="#FBF6F8"/>
<path transform="translate(1061,372)" d="m0 0h17v1l-15 1-1 2v10l1 7 2 4v10l-1 4v24l1 9v27l-3 14h5v1h-6l-1-1-1-11v-94z" fill="#921791"/>
<path transform="translate(688,595)" d="m0 0h1v8l6-1v33l94 1v1l-65 1 34 1v1h-73v-3h-6v-1h9z" fill="#D1D3D3"/>
<path transform="translate(472,284)" d="m0 0 3 4 1 5h22l49 1-5 4h-86v-2l9-7z" fill="#D2D0D2"/>
<path transform="translate(209,510)" d="m0 0h22l15 3 12 5 10 7 9 9 7 11-1 2-19-19-14-8-17-5h-25l-11-2v-1z" fill="#D7C6CE"/>
<path transform="translate(725,333)" d="m0 0h72l39 2 9 1v1l-35-1h-60l-38 1-4 1-1 2-1 25h-1v-27l2-3 4-1z" fill="#921791"/>
<path transform="translate(190,570)" d="m0 0 10 2 10 3-1 10-14 3h-6l-1-3v-9z" fill="#F18FB7"/>
<path transform="translate(218,594)" d="m0 0h10l3 14v6l-3 1h-7l-8-2 1-8z" fill="#F18FB7"/>
<path transform="translate(256,575)" d="m0 0h2v13l-3 6-18-6-1-3 1-7 12-2z" fill="#F18FB7"/>
<path transform="translate(1006,333)" d="m0 0h76l38 2 9 1v1l-35-1h-68l-33 1-4 1-2 19h-1v-15l2-7z" fill="#921791"/>
<path transform="translate(216,548)" d="m0 0h15l4 2-3 11-2 6-11-1z" fill="#F18FB7"/>
<path transform="translate(1990,296)" d="m0 0h23l-4 3 1 2h-52v33h-1v-37z" fill="#D5CAD0"/>
<path transform="translate(1311,333)" d="m0 0h39l3 2 1 4v20h-1l-1-23-98 1-1 3 1-5 15-1z" fill="#921791"/>
<path transform="translate(353,557)" d="m0 0h19l-2 15-7-1-7-6-3-6z" fill="#F9F7F8"/>
<path transform="translate(208,588)" d="m0 0 4 1 2 3-12 12-4 1-5-6 2-4z" fill="#692A8C"/>
<path transform="translate(280,543)" d="m0 0 5 4 5 15 2 14-1 16-3 13-3-1 1-6 2-9v-21l-3-12-5-10z" fill="#EBD2DD"/>
<path transform="translate(234,589)" d="m0 0 7 4 9 7-1 4-3 3-4-1-11-13z" fill="#692A8C"/>
<path transform="translate(202,554)" d="m0 0 4 1 9 12-1 4h-3l-13-10v-4z" fill="#6A2A8C"/>
<path transform="translate(248,559)" d="m0 0 4 1 2 6-15 7-5-1 1-4z" fill="#692A8C"/>
<path transform="translate(330,507)" d="m0 0 2 3 6 14 8 11 8 7 8 4 9 2 1 2-10-1-12-6-9-9-8-14-3-9z" fill="#DF0086"/>
<path transform="translate(2037,287)" d="m0 0 4 1 1 5-1 2 2 1-53 1h-25v-1l24-1h45v-2l2-1z" fill="#7C218E"/>
<path transform="translate(1614,522)" d="m0 0 2 1 11 23 7 10-1 3-6-7-6-10-6-14z" fill="#60257C"/>
<path transform="translate(372,505)" d="m0 0h6l-1 3h-42v-1l5-1z" fill="#DF0086"/>
<path transform="translate(2037,287)" d="m0 0 4 1 1 5-1 2 2 1h-17v-1h8v-2l2-1z" fill="#692A8C"/>
<path transform="translate(285,533)" d="m0 0 4 2 7 14-1 4-10-18z" fill="#60257C"/>
<path transform="translate(280,543)" d="m0 0 5 4 3 8v5l-2-1-6-13z" fill="#EDD9E1"/>
<path transform="translate(288,558)" d="m0 0 2 4 1 11-1 10h-1l-1-15-1-8z" fill="#E7BFD0"/>
<path transform="translate(290,573)" d="m0 0 2 3-1 16-2 1v-10z" fill="#F1D8E2"/>
<path transform="translate(1614,522)" d="m0 0 2 1 6 13v2l-4-2-4-11z" fill="#65247F"/>
<path transform="translate(1611,387)" d="m0 0h2l-2 5-3 4h-3l2-5z" fill="#D5CBD0"/>
<path transform="translate(849,522)" d="m0 0h2l5 9-1 4-6-11z" fill="#64247E"/>
</svg>
          <div className="flex gap-3 items-center">
            <button
              onClick={() => setShowCookiePolicy(true)}
              className="text-sm text-gray-600 hover:text-indigo-600 transition"
            >
              Cookies
            </button>
            <button
              onClick={() => setShowPrivacyPolicy(true)}
              className="text-sm text-gray-600 hover:text-indigo-600 transition"
            >
              Privacidad
            </button>
            <button
              onClick={() => setShowLegalNotice(true)}
              className="text-sm text-gray-600 hover:text-indigo-600 transition"
            >
              Aviso Legal
            </button>
            {isAdmin ? (
              <>
                <span className="px-4 py-2 bg-green-100 text-green-700 rounded-lg font-semibold flex items-center gap-2">
                  <Lock size={16} />
                  Modo Administrador
                </span>
                <button
                  onClick={handleLogout}
                  className="px-4 py-2 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition flex items-center gap-2"
                >
                  <LogOut size={16} />
                  Cerrar Sesión
                </button>
              </>
            ) : (
              <button
                onClick={() => setShowLogin(true)}
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700 transition flex items-center gap-2"
              >
                <Lock size={16} />
                Admin Login
              </button>
            )}
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex gap-4 mb-8">
          <button
            onClick={() => setActiveTab('pisos')}
            className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition ${
              activeTab === 'pisos'
                ? 'bg-indigo-600 text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            <Home size={20} />
            Pisos
          </button>
          <button
            onClick={() => setActiveTab('coches')}
            className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition ${
              activeTab === 'coches'
                ? 'bg-indigo-600 text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            <Car size={20} />
            Coches
          </button>
          {isAdmin && (
            <button
              onClick={() => openModal()}
              className="ml-auto flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition shadow-lg"
            >
              <Plus size={20} />
              Agregar {activeTab === 'pisos' ? 'Piso' : 'Coche'}
            </button>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item) => (
            <div key={item.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition relative">
              {item.imagenes && item.imagenes[0] && (
                <div className="relative">
                  <img
                    src={item.imagenes[0]}
                    alt={item.titulo}
                    className="w-full h-48 object-cover cursor-pointer"
                    onClick={() => openDetailModal(item)}
                  />
                  {item.estado === 'reservado' && (
                    <div className="absolute top-0 left-0 bg-yellow-500 text-white px-4 py-2 font-bold rounded-br-lg shadow-lg">
                      🔖 RESERVADO
                    </div>
                  )}
                  {item.estado === 'vendido' && (
                    <div className="absolute top-0 left-0 bg-red-600 text-white px-4 py-2 font-bold rounded-br-lg shadow-lg">
                      ✓ VENDIDO
                    </div>
                  )}
                </div>
              )}

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-2">{item.titulo}</h3>
                <p className="text-gray-600 mb-4 line-clamp-2">{item.descripcion}</p>
                <p className="text-2xl font-bold text-indigo-600 mb-4">{formatPrecio(item.precio)} €</p>
                
                {activeTab === 'pisos' ? (
                  <div className="text-sm text-gray-600 space-y-1">
                    <p>📍 {item.ubicacion}</p>
                    <p>📐 {item.metros} m²</p>
                    <p>🛏️ {item.habitaciones} hab. | 🚿 {item.banos} baños</p>
                  </div>
                ) : (
                  <div className="text-sm text-gray-600 space-y-1">
                    <p>🚗 {item.marca} {item.modelo}</p>
                    <p>📅 Año: {item.ano}</p>
                    <p>🛣️ {item.kilometros} km</p>
                  </div>
                )}

                {isAdmin ? (
                  <div className="space-y-2">
                    <div className="flex gap-2">
                      <button
                        onClick={() => openDetailModal(item)}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition"
                      >
                        <Eye size={16} />
                        Ver
                      </button>
                      <button
                        onClick={() => openModal(item)}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                      >
                        <Edit2 size={16} />
                        Editar
                      </button>
                      <button
                        onClick={() => handleDelete(item.id)}
                        className="flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleEstadoChange(item.id, 'disponible')}
                        className={`flex-1 px-3 py-2 text-sm rounded-lg transition ${
                          item.estado === 'disponible'
                            ? 'bg-green-600 text-white'
                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        }`}
                      >
                        Disponible
                      </button>
                      <button
                        onClick={() => handleEstadoChange(item.id, 'reservado')}
                        className={`flex-1 px-3 py-2 text-sm rounded-lg transition ${
                          item.estado === 'reservado'
                            ? 'bg-yellow-500 text-white'
                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        }`}
                      >
                        Reservado
                      </button>
                      <button
                        onClick={() => handleEstadoChange(item.id, 'vendido')}
                        className={`flex-1 px-3 py-2 text-sm rounded-lg transition ${
                          item.estado === 'vendido'
                            ? 'bg-red-600 text-white'
                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        }`}
                      >
                        Vendido
                      </button>
                    </div>
                  </div>
                ) : (
                  <button 
                    onClick={() => openDetailModal(item)}
                    className="w-full mt-4 flex items-center justify-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition"
                  >
                    <Eye size={16} />
                    Ver Detalles
                  </button>

                )}
<div className="flex gap-2 mt-3">
  <button
    onClick={() => shareWhatsApp(item)}
    className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition"
  >
    📲 WhatsApp
  </button>

  <button
    onClick={() => shareEmail(item)}
    className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition"
  >
    ✉️ Email
  </button>
</div>

                {!isAdmin && (
                  <button 
                    onClick={() => openContactModal(item)}
                    className="w-full mt-2 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                  >
                    <Mail size={16} />
                    Contactar
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {items.length === 0 && (
          <div className="text-center py-16">
            <p className="text-gray-500 text-lg">No hay {activeTab} registrados</p>
          </div>
        )}
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white mt-16">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Información de la empresa */}
            <div>
              <div className="flex items-center gap-2 mb-4">
                <Building size={32} className="text-indigo-400" />
                <h3 className="text-2xl font-bold">Karpiso</h3>
              </div>
              <p className="text-gray-400 mb-4">
                Con Karpiso, encuentra tu hogar y tu coche, sin complicaciones!
              </p>
              <div className="flex gap-3">
                <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-indigo-600 rounded-full flex items-center justify-center transition">
                  <span className="text-xl">📘</span>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-indigo-600 rounded-full flex items-center justify-center transition">
                  <span className="text-xl">📷</span>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-indigo-600 rounded-full flex items-center justify-center transition">
                  <span className="text-xl">🐦</span>
                </a>
              </div>
            </div>

            {/* Contacto */}
            <div>
              <h3 className="text-xl font-bold mb-4 text-indigo-400">Contacto</h3>
              <div className="space-y-3">
                <a href="tel:+34900123456" className="flex items-center gap-3 text-gray-300 hover:text-white transition group">
                  <div className="w-10 h-10 bg-gray-800 group-hover:bg-indigo-600 rounded-lg flex items-center justify-center transition">
                    <Phone size={20} />
                  </div>
                  <div>
                    <p className="text-sm text-gray-400">Teléfono</p>
                    <p className="font-semibold">+34 619 162 617</p>
                  </div>
                </a>
                
                <a href="mailto: karpiso2025@gmail.com" className="flex items-center gap-3 text-gray-300 hover:text-white transition group">
                  <div className="w-10 h-10 bg-gray-800 group-hover:bg-indigo-600 rounded-lg flex items-center justify-center transition">
                    <Mail size={20} />
                  </div>
                  <div>
                    <p className="text-sm text-gray-400">Email</p>
                    <p className="font-semibold"> karpiso2025@gmail.com</p>
                  </div>
                </a>

                <div className="flex items-start gap-3 text-gray-300">
                  <div className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock size={20} />
                  </div>
                  <div>
                    <p className="text-sm text-gray-400">Horario</p>
                    <p className="font-semibold">Lun - Jue: 10:30 - 13:00 -- 17:30 - 20:00</p>
<p className="font-semibold">Vie - Jue: 10:30 - 13:00 -- 17:00 - 19:00</p>
                    <p className="text-sm">Sab y Dom con cita previa</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Ubicación */}
            <div>
              <h3 className="text-xl font-bold mb-4 text-indigo-400">Nuestra Oficina</h3>
              <div className="flex items-start gap-3 text-gray-300 mb-4">
                <div className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin size={20} />
                </div>
                <div>
                  <p className="font-semibold mb-1">Dirección</p>
                  <p className="text-sm text-gray-400">
                  Calle Joaquin Turina, 31 Bis Local<br />
                    Madrid<br />
                    España
                  </p>
                </div>
              </div>
              
              <button
                onClick={() => openContactModal()}
                className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-indigo-600 hover:bg-indigo-700 rounded-lg font-semibold transition"
              >
                <Mail size={20} />
                Contáctanos
              </button>
            </div>
          </div>

          {/* Línea divisoria */}
          <div className="border-t border-gray-800 mt-8 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-400 text-sm">
                © 2025 Karpiso. Todos los derechos reservados.
              </p>
              <div className="flex gap-6 text-sm">
                <button
                  onClick={() => setShowCookiePolicy(true)}
                  className="text-gray-400 hover:text-white transition"
                >
                  Política de Cookies
                </button>
                <button
                  onClick={() => setShowLegalNotice(true)}
                  className="text-gray-400 hover:text-white transition"
                >
                  Aviso Legal
                </button>
                <button
                  onClick={() => setShowPrivacyPolicy(true)}
                  className="text-gray-400 hover:text-white transition"
                >
                  Política de Privacidad
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {showDetailModal && selectedItem && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-50" onClick={closeDetailModal}>
          <div className="bg-white rounded-xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center z-10">
              <h2 className="text-2xl font-bold text-gray-800">{selectedItem.titulo}</h2>
              <button onClick={closeDetailModal} className="text-gray-500 hover:text-gray-700">
                <X size={24} />
              </button>
            </div>

            <div className="p-6">
              {selectedItem.imagenes && selectedItem.imagenes.length > 0 ? (
                <div className="mb-6">
                  <div className="relative bg-gray-100 rounded-lg overflow-hidden">
                    <img
                      src={selectedItem.imagenes[currentImageIndex]}
                      alt={`Imagen ${currentImageIndex + 1}`}
                      className="w-full h-96 object-contain"
                    />
                    
                    {selectedItem.imagenes.length > 1 && (
                      <>
                        <button
                          onClick={prevImage}
                          className="absolute left-4 top-1/2 -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 p-3 rounded-full shadow-lg transition"
                        >
                          <ChevronLeft size={24} />
                        </button>
                        <button
                          onClick={nextImage}
                          className="absolute right-4 top-1/2 -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 p-3 rounded-full shadow-lg transition"
                        >
                          <ChevronRight size={24} />
                        </button>
                        
                        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black bg-opacity-60 text-white px-4 py-2 rounded-full text-sm">
                          {currentImageIndex + 1} / {selectedItem.imagenes.length}
                        </div>
                      </>
                    )}
                  </div>

                  {selectedItem.imagenes.length > 1 && (
                    <div className="flex gap-2 mt-4 overflow-x-auto pb-2">
                      {selectedItem.imagenes.map((img, idx) => (
                        <img
                          key={idx}
                          src={img}
                          alt={`Miniatura ${idx + 1}`}
                          onClick={() => setCurrentImageIndex(idx)}
                          className={`w-20 h-20 object-cover rounded cursor-pointer transition ${
                            idx === currentImageIndex ? 'ring-4 ring-indigo-600' : 'opacity-60 hover:opacity-100'
                          }`}
                        />
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <div className="bg-gray-200 h-96 flex items-center justify-center rounded-lg mb-6">
                  <p className="text-gray-500">Sin imágenes</p>
                </div>
              )}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-bold text-gray-800 mb-2">Descripción</h3>
                    <p className="text-gray-600">{selectedItem.descripcion}</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-bold text-gray-800 mb-2">Precio</h3>
                    <p className="text-3xl font-bold text-indigo-600">{formatPrecio(selectedItem.precio)} €</p>
                    {selectedItem.estado && (
                      <div className="mt-2">
                        {selectedItem.estado === 'disponible' && (
                          <span className="inline-block px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-semibold">
                            ✓ Disponible
                          </span>
                        )}
                        {selectedItem.estado === 'reservado' && (
                          <span className="inline-block px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-sm font-semibold">
                            🔖 Reservado
                          </span>
                        )}
                        {selectedItem.estado === 'vendido' && (
                          <span className="inline-block px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm font-semibold">
                            ✓ Vendido
                          </span>
                        )}
                      </div>
                    )}
                  </div>

                  {activeTab === 'pisos' ? (
                    <div>
                      <h3 className="text-lg font-bold text-gray-800 mb-2">Características</h3>
                      <div className="space-y-2 text-gray-600">
                        <p className="flex items-center gap-2">
                          <MapPin size={18} className="text-indigo-600" />
                          <span className="font-semibold">Ubicación:</span> {selectedItem.ubicacion}
                        </p>
                        <p>📐 <span className="font-semibold">Superficie:</span> {selectedItem.metros} m²</p>
                        <p>🛏️ <span className="font-semibold">Habitaciones:</span> {selectedItem.habitaciones}</p>
                        <p>🚿 <span className="font-semibold">Baños:</span> {selectedItem.banos}</p>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <h3 className="text-lg font-bold text-gray-800 mb-2">Características</h3>
                      <div className="space-y-2 text-gray-600">
                        <p>🚗 <span className="font-semibold">Marca:</span> {selectedItem.marca}</p>
                        <p>🏷️ <span className="font-semibold">Modelo:</span> {selectedItem.modelo}</p>
                        <p>📅 <span className="font-semibold">Año:</span> {selectedItem.ano}</p>
                        <p>🛣️ <span className="font-semibold">Kilómetros:</span> {selectedItem.kilometros} km</p>
                      </div>
                    </div>
                  )}
                </div>

                {activeTab === 'pisos' && selectedItem.ubicacion && (
                  <div>
                    <h3 className="text-lg font-bold text-gray-800 mb-2">Ubicación</h3>
                    <div className="relative rounded-lg overflow-hidden shadow-lg">
                      <iframe
                        width="100%"
                        height="300"
                        style={{ border: 0 }}
                        loading="lazy"
                        allowFullScreen
                        referrerPolicy="no-referrer-when-downgrade"
                        src={getMapUrl(selectedItem.ubicacion)}
                        title="Mapa de ubicación"
                      />
                      <a
                        href={getGoogleMapsLink(selectedItem.ubicacion)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="absolute top-3 right-3 bg-white hover:bg-gray-100 px-4 py-2 rounded-lg shadow-md text-sm font-semibold text-gray-700 transition flex items-center gap-2"
                      >
                        <MapPin size={16} />
                        Abrir en Google Maps
                      </a>
                    </div>
                  </div>
                )}
              </div>

              {!isAdmin && (
                <div className="mt-6 p-6 bg-indigo-50 rounded-lg">
                  <h3 className="text-lg font-bold text-gray-800 mb-3">¿Interesado en esta propiedad?</h3>
                  <button
                    onClick={() => {
                      closeDetailModal();
                      openContactModal(selectedItem);
                    }}
                    className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition"
                  >
                    <Mail size={20} />
                    Contactar Ahora
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showLogin && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-8">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
                <Lock size={24} />
                Login Administrador
              </h2>
              <button onClick={() => setShowLogin(false)} className="text-gray-500 hover:text-gray-700">
                <X size={24} />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Usuario</label>
                <input
                  type="text"
                  value={loginData.username}
                  onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
                  onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                  placeholder="admin"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Contraseña</label>
                <input
                  type="password"
                  value={loginData.password}
                  onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                  onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                  placeholder="••••••••"
                />
              </div>

              <button
                onClick={handleLogin}
                className="w-full px-6 py-3 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700 transition"
              >
                Iniciar Sesión
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal && isAdmin && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
              <h2 className="text-2xl font-bold text-gray-800">
                {editingItem ? 'Editar' : 'Agregar'} {activeTab === 'pisos' ? 'Piso' : 'Coche'}
              </h2>
              <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">
                <X size={24} />
              </button>
            </div>

            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Título <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  required
                  value={formData.titulo}
                  onChange={(e) => setFormData({ ...formData, titulo: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                  placeholder="Título del anuncio"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Descripción <span className="text-red-500">*</span>
                </label>
                <textarea
                  required
                  value={formData.descripcion}
                  onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
                  rows="3"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                  placeholder="Describe las características principales"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Precio (€) <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  required
                  min="1"
                  value={formData.precio}
                  onChange={(e) => setFormData({ ...formData, precio: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                  placeholder="Precio en euros"
                />
              </div>

              {activeTab === 'pisos' ? (
                <>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Ubicación <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      value={formData.ubicacion}
                      onChange={(e) => setFormData({ ...formData, ubicacion: e.target.value })}
                      placeholder="Ej: Calle Mayor 123, Barcelona"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    />
                  </div>
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Metros² <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        required
                        min="1"
                        value={formData.metros}
                        onChange={(e) => setFormData({ ...formData, metros: e.target.value })}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        placeholder="85"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Habitaciones <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        required
                        min="1"
                        value={formData.habitaciones}
                        onChange={(e) => setFormData({ ...formData, habitaciones: e.target.value })}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        placeholder="3"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Baños <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        required
                        min="1"
                        value={formData.banos}
                        onChange={(e) => setFormData({ ...formData, banos: e.target.value })}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        placeholder="2"
                      />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Marca <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        required
                        value={formData.marca}
                        onChange={(e) => setFormData({ ...formData, marca: e.target.value })}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        placeholder="Toyota"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Modelo <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        required
                        value={formData.modelo}
                        onChange={(e) => setFormData({ ...formData, modelo: e.target.value })}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        placeholder="Corolla"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Año <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        required
                        min="1900"
                        max={new Date().getFullYear() + 1}
                        value={formData.ano}
                        onChange={(e) => setFormData({ ...formData, ano: e.target.value })}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        placeholder="2020"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Kilómetros <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        required
                        min="0"
                        value={formData.kilometros}
                        onChange={(e) => setFormData({ ...formData, kilometros: e.target.value })}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                        placeholder="50000"
                      />
                    </div>
                  </div>
                </>
              )}

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Imágenes <span className="text-red-500">*</span>
                </label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-4">
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageUpload}
                    className="hidden"
                    id="image-upload"
                  />
                  <label
                    htmlFor="image-upload"
                    className="flex flex-col items-center justify-center cursor-pointer"
                  >
                    <Upload className="text-gray-400 mb-2" size={32} />
                    <span className="text-sm text-gray-600">Click para subir imágenes (mínimo 1)</span>
                  </label>
                </div>
                {formData.imagenes && formData.imagenes.length > 0 && (
                  <div className="grid grid-cols-4 gap-2 mt-4">
                    {formData.imagenes.map((img, index) => (
                      <div key={index} className="relative">
                        <img src={getImageSrc(img)} alt={`Preview ${index}`} className="w-full h-20 object-cover rounded" />
                        <button
                          type="button"
                          onClick={() => removeImage(index)}
                          className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                        >
                          <X size={12} />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
                {formData.imagenes && formData.imagenes.length > 0 && (
                  <p className="text-sm text-green-600 mt-2">✓ {formData.imagenes.length} imagen(es) seleccionada(s)</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Estado <span className="text-red-500">*</span>
                </label>
                <div className="grid grid-cols-3 gap-3">
                  <button
                    type="button"
                    onClick={() => setFormData({ ...formData, estado: 'disponible' })}
                    className={`px-4 py-3 rounded-lg font-semibold transition ${
                      formData.estado === 'disponible'
                        ? 'bg-green-600 text-white ring-2 ring-green-600 ring-offset-2'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                  >
                    ✓ Disponible
                  </button>
                  <button
                    type="button"
                    onClick={() => setFormData({ ...formData, estado: 'reservado' })}
                    className={`px-4 py-3 rounded-lg font-semibold transition ${
                      formData.estado === 'reservado'
                        ? 'bg-yellow-500 text-white ring-2 ring-yellow-500 ring-offset-2'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                  >
                    🔖 Reservado
                  </button>
                  <button
                    type="button"
                    onClick={() => setFormData({ ...formData, estado: 'vendido' })}
                    className={`px-4 py-3 rounded-lg font-semibold transition ${
                      formData.estado === 'vendido'
                        ? 'bg-red-600 text-white ring-2 ring-red-600 ring-offset-2'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                  >
                    ✓ Vendido
                  </button>
                </div>
              </div>

              <div className="flex gap-4 pt-4">
                <button
                  onClick={closeModal}
                  className="flex-1 px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition"
                >
                  Cancelar
                </button>
                <button
                  onClick={handleSubmit}
                  className="flex-1 px-6 py-3 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700 transition"
                >
                  {editingItem ? 'Actualizar' : 'Crear'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showContactModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full">
            <div className="bg-indigo-600 text-white px-6 py-4 rounded-t-xl flex justify-between items-center">
              <div className="flex items-center gap-2">
                <Mail size={24} />
                <h2 className="text-2xl font-bold">Formulario de Contacto</h2>
              </div>
              <button onClick={closeContactModal} className="text-white hover:text-gray-200">
                <X size={24} />
              </button>
            </div>

            <div className="p-6">
              {selectedItem && (
                <div className="mb-6 p-4 bg-indigo-50 rounded-lg">
                  <p className="text-sm text-gray-600">Consultando sobre:</p>
                  <p className="font-bold text-gray-800">{selectedItem.titulo}</p>
                  <p className="text-indigo-600 font-semibold">{formatPrecio(selectedItem.precio)} €</p>
                </div>
              )}

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    <User size={16} className="inline mr-1" />
                    Nombre completo <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    value={contactForm.nombre}
                    onChange={(e) => setContactForm({ ...contactForm, nombre: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    placeholder="Tu nombre"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    <Mail size={16} className="inline mr-1" />
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    required
                    value={contactForm.email}
                    onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    placeholder="tu@email.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    <Phone size={16} className="inline mr-1" />
                    Teléfono (opcional)
                  </label>
                  <input
                    type="tel"
                    value={contactForm.telefono}
                    onChange={(e) => setContactForm({ ...contactForm, telefono: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    placeholder="+34 600 000 000"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    <MessageSquare size={16} className="inline mr-1" />
                    Mensaje <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    required
                    value={contactForm.mensaje}
                    onChange={(e) => setContactForm({ ...contactForm, mensaje: e.target.value })}
                    rows="5"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    placeholder="Cuéntanos en qué podemos ayudarte..."
                  />
                </div>

                <div className="flex gap-4 pt-4">
                  <button
                    onClick={closeContactModal}
                    className="flex-1 px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleContactSubmit}
                    className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition flex items-center justify-center gap-2"
                  >
                    <Mail size={20} />
                    Enviar Mensaje
                  </button>
                </div>
              </div>

              <p className="text-xs text-gray-500 text-center mt-4">
                Al enviar este formulario, aceptas que te contactemos por email o teléfono.
              </p>
            </div>
          </div>
        </div>
      )}

      {showCookieBanner && (
        <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-6 shadow-2xl z-50">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex-1">
              <h3 className="text-lg font-bold mb-2">🍪 Uso de Cookies</h3>
              <p className="text-sm text-gray-300">
                Utilizamos cookies propias y de terceros para mejorar tu experiencia de navegación. 
                Al continuar navegando, aceptas nuestra{' '}
                <button
                  onClick={() => setShowCookiePolicy(true)}
                  className="text-indigo-400 hover:text-indigo-300 underline"
                >
                  Política de Cookies
                </button>
                .
              </p>
            </div>
            <div className="flex gap-3">
              <button
                onClick={rejectCookies}
                className="px-6 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg font-semibold transition"
              >
                Rechazar
              </button>
              <button
                onClick={acceptCookies}
                className="px-6 py-2 bg-indigo-600 hover:bg-indigo-700 rounded-lg font-semibold transition"
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      )}

      {showCookiePolicy && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-y-auto">
          <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full my-8">
            <div className="sticky top-0 bg-indigo-600 text-white px-6 py-4 rounded-t-xl flex justify-between items-center">
              <h2 className="text-2xl font-bold">🍪 Política de Cookies</h2>
              <button onClick={() => setShowCookiePolicy(false)} className="text-white hover:text-gray-200">
                <X size={24} />
              </button>
            </div>

            <div className="p-6 max-h-[70vh] overflow-y-auto">
              <div className="prose max-w-none">
                <p className="text-gray-600 mb-4">
                  <strong>Última actualización:</strong> Diciembre 2025
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">¿Qué son las cookies?</h3>
                <p className="text-gray-700 mb-4">
                  Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. 
                  Se utilizan ampliamente para hacer que los sitios web funcionen de manera más eficiente y proporcionar 
                  información a los propietarios del sitio.
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">¿Qué cookies utilizamos?</h3>
                
                <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4">
                  <h4 className="font-bold text-blue-900 mb-2">🔹 Cookies Esenciales (Obligatorias)</h4>
                  <p className="text-gray-700 text-sm">
                    Estas cookies son necesarias para el funcionamiento básico del sitio web y no se pueden desactivar.
                  </p>
                  <ul className="mt-2 text-sm text-gray-600 list-disc list-inside">
                    <li><strong>adminSession:</strong> Mantiene tu sesión de administrador activa</li>
                    <li><strong>cookiesAccepted:</strong> Recuerda tu elección sobre las cookies</li>
                  </ul>
                </div>

                <div className="bg-green-50 border-l-4 border-green-500 p-4 mb-4">
                  <h4 className="font-bold text-green-900 mb-2">🔹 Cookies de Funcionalidad</h4>
                  <p className="text-gray-700 text-sm">
                    Permiten recordar tus preferencias y mejorar tu experiencia.
                  </p>
                  <ul className="mt-2 text-sm text-gray-600 list-disc list-inside">
                    <li>Preferencias de visualización</li>
                    <li>Configuración de idioma</li>
                  </ul>
                </div>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">¿Cómo gestionar las cookies?</h3>
                <p className="text-gray-700 mb-4">
                  Puedes configurar tu navegador para rechazar cookies o para que te avise cuando se envíen cookies. 
                  Sin embargo, algunas partes del sitio pueden no funcionar correctamente si lo haces.
                </p>

                <div className="bg-gray-100 p-4 rounded-lg mb-4">
                  <p className="font-semibold text-gray-800 mb-2">Instrucciones por navegador:</p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li><strong>Chrome:</strong> Configuración → Privacidad y seguridad → Cookies</li>
                    <li><strong>Firefox:</strong> Opciones → Privacidad y seguridad → Cookies</li>
                    <li><strong>Safari:</strong> Preferencias → Privacidad → Cookies</li>
                    <li><strong>Edge:</strong> Configuración → Privacidad → Cookies</li>
                  </ul>
                </div>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">Duración de las cookies</h3>
                <p className="text-gray-700 mb-4">
                  Las cookies que utilizamos son cookies de sesión (se eliminan al cerrar el navegador) y cookies 
                  persistentes (permanecen hasta que las elimines o caduquen).
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">Tus derechos</h3>
                <p className="text-gray-700 mb-4">
                  Tienes derecho a:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-1">
                  <li>Aceptar o rechazar cookies no esenciales</li>
                  <li>Retirar tu consentimiento en cualquier momento</li>
                  <li>Eliminar cookies almacenadas en tu dispositivo</li>
                  <li>Recibir información clara sobre el uso de cookies</li>
                </ul>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">Actualizaciones de esta política</h3>
                <p className="text-gray-700 mb-4">
                  Podemos actualizar esta Política de Cookies ocasionalmente. Te notificaremos sobre cambios 
                  significativos mediante un aviso en nuestro sitio web.
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">Contacto</h3>
                <p className="text-gray-700 mb-4">
                  Si tienes preguntas sobre nuestra Política de Cookies, contáctanos a través del formulario 
                  de contacto o en: <strong>karpiso2025@gmail.com</strong>
                </p>

                <div className="bg-indigo-50 border border-indigo-200 p-4 rounded-lg mt-6">
                  <p className="text-sm text-gray-700">
                    <strong>Nota:</strong> Al usar este sitio web, aceptas el uso de cookies de acuerdo con esta 
                    Política de Cookies. Si no estás de acuerdo, puedes configurar tu navegador para rechazarlas 
                    o abandonar el sitio.
                  </p>
                </div>
              </div>
            </div>

            <div className="border-t px-6 py-4 bg-gray-50 rounded-b-xl">
              <div className="flex gap-4 justify-end">
                <button
                  onClick={() => {
                    setShowCookiePolicy(false);
                    rejectCookies();
                  }}
                  className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition"
                >
                  Rechazar Cookies
                </button>
                <button
                  onClick={() => {
                    setShowCookiePolicy(false);
                    acceptCookies();
                  }}
                  className="px-6 py-2 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700 transition"
                >
                  Aceptar y Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPrivacyPolicy && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-y-auto">
          <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full my-8">
            <div className="sticky top-0 bg-indigo-600 text-white px-6 py-4 rounded-t-xl flex justify-between items-center">
              <h2 className="text-2xl font-bold">🔒 Política de Privacidad</h2>
              <button onClick={() => setShowPrivacyPolicy(false)} className="text-white hover:text-gray-200">
                <X size={24} />
              </button>
            </div>

            <div className="p-6 max-h-[70vh] overflow-y-auto">
              <div className="prose max-w-none">
                <p className="text-gray-600 mb-4">
                  <strong>Última actualización:</strong> Diciembre 2025
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">1. Responsable del Tratamiento</h3>
                <div className="bg-indigo-50 p-4 rounded-lg mb-4">
                  <p className="text-gray-700 mb-2"><strong>Identidad:</strong> Karpiso S.L.</p>
                  <p className="text-gray-700 mb-2"><strong>Dirección:</strong> Calle Joaquin Turina, 31 Bis local, Madrid</p>
                  <p className="text-gray-700 mb-2"><strong>Email:</strong>  karpiso2025@gmail.com</p>
                  <p className="text-gray-700"><strong>Teléfono:</strong> +34 619 162 617</p>
                </div>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">2. Finalidad del Tratamiento de Datos</h3>
                <p className="text-gray-700 mb-4">
                  Tratamos la información que nos facilitas con las siguientes finalidades:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                  <li><strong>Gestión de consultas:</strong> Responder a tus solicitudes de información sobre propiedades</li>
                  <li><strong>Envío de información comercial:</strong> Informarte sobre nuevas propiedades y servicios</li>
                  <li><strong>Gestión de la relación contractual:</strong> Gestión de la compra/venta de propiedades</li>
                  <li><strong>Mejora de servicios:</strong> Análisis estadísticos para mejorar nuestra web y servicios</li>
                  <li><strong>Cumplimiento legal:</strong> Cumplir con obligaciones legales aplicables</li>
                </ul>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">3. Legitimación</h3>
                <p className="text-gray-700 mb-4">
                  La base legal para el tratamiento de tus datos es:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-1">
                  <li>Tu consentimiento explícito al rellenar nuestros formularios</li>
                  <li>La ejecución de un contrato en el que eres parte</li>
                  <li>El cumplimiento de obligaciones legales</li>
                  <li>Interés legítimo para mejorar nuestros servicios</li>
                </ul>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">4. Datos que Recopilamos</h3>
                <div className="space-y-3 mb-4">
                  <div className="bg-blue-50 border-l-4 border-blue-500 p-4">
                    <h4 className="font-bold text-blue-900 mb-2">📋 Datos de Contacto</h4>
                    <p className="text-gray-700 text-sm">Nombre, apellidos, email, teléfono, dirección</p>
                  </div>
                  <div className="bg-green-50 border-l-4 border-green-500 p-4">
                    <h4 className="font-bold text-green-900 mb-2">🔍 Datos de Navegación</h4>
                    <p className="text-gray-700 text-sm">Dirección IP, tipo de navegador, páginas visitadas, tiempo de permanencia</p>
                  </div>
                  <div className="bg-purple-50 border-l-4 border-purple-500 p-4">
                    <h4 className="font-bold text-purple-900 mb-2">💼 Datos de Interés</h4>
                    <p className="text-gray-700 text-sm">Preferencias de propiedades, búsquedas realizadas, consultas efectuadas</p>
                  </div>
                </div>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">5. Destinatarios de los Datos</h3>
                <p className="text-gray-700 mb-4">
                  Tus datos podrán ser comunicados a:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-1">
                  <li>Proveedores de servicios tecnológicos (hosting, email)</li>
                  <li>Entidades bancarias para la gestión de pagos</li>
                  <li>Asesores legales y fiscales</li>
                  <li>Organismos públicos cuando sea obligatorio por ley</li>
                </ul>
                <p className="text-gray-700 mb-4">
                  <strong>No cedemos ni vendemos</strong> tus datos a terceros con fines comerciales sin tu consentimiento explícito.
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">6. Conservación de los Datos</h3>
                <p className="text-gray-700 mb-4">
                  Conservaremos tus datos personales durante:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-1">
                  <li><strong>Datos de contacto:</strong> Hasta que solicites su supresión o retires el consentimiento</li>
                  <li><strong>Datos contractuales:</strong> Durante la relación contractual y 6 años tras su finalización</li>
                  <li><strong>Datos fiscales:</strong> 6 años desde la última operación (obligación legal)</li>
                </ul>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">7. Tus Derechos</h3>
                <p className="text-gray-700 mb-4">
                  Tienes derecho a:
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
                  <div className="bg-gray-50 p-3 rounded">
                    <p className="font-bold text-gray-800">✓ Acceso</p>
                    <p className="text-sm text-gray-600">Conocer qué datos tenemos sobre ti</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded">
                    <p className="font-bold text-gray-800">✓ Rectificación</p>
                    <p className="text-sm text-gray-600">Corregir datos inexactos</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded">
                    <p className="font-bold text-gray-800">✓ Supresión</p>
                    <p className="text-sm text-gray-600">Eliminar tus datos (derecho al olvido)</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded">
                    <p className="font-bold text-gray-800">✓ Oposición</p>
                    <p className="text-sm text-gray-600">Oponerte al tratamiento de tus datos</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded">
                    <p className="font-bold text-gray-800">✓ Limitación</p>
                    <p className="text-sm text-gray-600">Limitar el tratamiento</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded">
                    <p className="font-bold text-gray-800">✓ Portabilidad</p>
                    <p className="text-sm text-gray-600">Recibir tus datos en formato estructurado</p>
                  </div>
                </div>

                <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg mb-4">
                  <h4 className="font-bold text-gray-800 mb-2">📧 ¿Cómo ejercer tus derechos?</h4>
                  <p className="text-gray-700 text-sm">
                    Envía un email a <strong> karpiso2025@gmail.com</strong> indicando:
                  </p>
                  <ul className="text-sm text-gray-700 mt-2 space-y-1">
                    <li>• Nombre completo y email</li>
                    <li>• Derecho que deseas ejercer</li>
                    <li>• Copia de tu DNI o documento equivalente</li>
                  </ul>
                  <p className="text-sm text-gray-600 mt-2">
                    Responderemos tu solicitud en un plazo máximo de 1 mes.
                  </p>
                </div>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">8. Seguridad de los Datos</h3>
                <p className="text-gray-700 mb-4">
                  Implementamos medidas técnicas y organizativas apropiadas para proteger tus datos:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-1">
                  <li>Cifrado SSL/TLS en todas las comunicaciones</li>
                  <li>Acceso restringido a datos personales</li>
                  <li>Auditorías de seguridad periódicas</li>
                  <li>Copias de seguridad regulares</li>
                  <li>Formación del personal en protección de datos</li>
                </ul>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">9. Menores de Edad</h3>
                <p className="text-gray-700 mb-4">
                  Nuestros servicios no están dirigidos a menores de 18 años. Si eres menor, necesitas el 
                  consentimiento de tus padres o tutores para usar nuestros servicios.
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">10. Reclamaciones</h3>
                <p className="text-gray-700 mb-4">
                  Si consideras que no hemos tratado tus datos correctamente, puedes presentar una reclamación ante:
                </p>
                <div className="bg-indigo-50 p-4 rounded-lg mb-4">
                  <p className="font-bold text-gray-800">Agencia Española de Protección de Datos (AEPD)</p>
                  <p className="text-gray-700">C/ Jorge Juan, 6, 28001 Madrid</p>
                  <p className="text-gray-700">Web: www.aepd.es</p>
                  <p className="text-gray-700">Teléfono: 901 100 099 / 912 663 517</p>
                </div>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">11. Modificaciones</h3>
                <p className="text-gray-700 mb-4">
                  Nos reservamos el derecho a modificar esta Política de Privacidad para adaptarla a cambios 
                  legislativos o jurisprudenciales. Te notificaremos cualquier cambio sustancial.
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">12. Contacto</h3>
                <p className="text-gray-700 mb-4">
                  Para cualquier duda sobre esta Política de Privacidad, contacta con nosotros:
                </p>
                <div className="bg-gray-100 p-4 rounded-lg">
                  <p className="text-gray-700"><strong>Email:</strong>  karpiso2025@gmail.com</p>
                  <p className="text-gray-700"><strong>Teléfono:</strong> +34 619 162 617</p>
                  <p className="text-gray-700"><strong>Dirección:</strong> Calle Joaquin Turina, 31 Bis Local, Madrid</p>
                </div>
              </div>
            </div>

            <div className="border-t px-6 py-4 bg-gray-50 rounded-b-xl">
              <button
                onClick={() => setShowPrivacyPolicy(false)}
                className="w-full px-6 py-2 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700 transition"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {showLegalNotice && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-y-auto">
          <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full my-8">
            <div className="sticky top-0 bg-indigo-600 text-white px-6 py-4 rounded-t-xl flex justify-between items-center">
              <h2 className="text-2xl font-bold">⚖️ Aviso Legal</h2>
              <button onClick={() => setShowLegalNotice(false)} className="text-white hover:text-gray-200">
                <X size={24} />
              </button>
            </div>

            <div className="p-6 max-h-[70vh] overflow-y-auto">
              <div className="prose max-w-none">
                <p className="text-gray-600 mb-4">
                  <strong>Última actualización:</strong> Diciembre 2025
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">1. Datos Identificativos</h3>
                <div className="bg-indigo-50 p-4 rounded-lg mb-4">
                  <p className="text-gray-700 mb-2"><strong>Denominación Social:</strong> Karpiso S.L.</p>
                  <p className="text-gray-700 mb-2"><strong>Domicilio Social:</strong> Calle Joaquin Turina, 31 Bis local, Madrid</p>
                  <p className="text-gray-700 mb-2"><strong>Email:</strong> karpiso2025@gmail.com</p>
                  <p className="text-gray-700 mb-2"><strong>Teléfono:</strong> +34 619 162 617</p>
                  <p className="text-gray-700 mb-2"><strong>Registro Mercantil:</strong> Barcelona, Tomo 12345, Folio 123, Hoja B-123456</p>
                  <p className="text-gray-700"><strong>Actividad:</strong> Compraventa de inmuebles y vehículos</p>
                </div>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">2. Objeto</h3>
                <p className="text-gray-700 mb-4">
                  El presente Aviso Legal regula el uso del sitio web <strong>www.inmobiliariapremium.com</strong> 
                  (en adelante, "el Sitio Web") del que es titular Karpiso S.L.
                </p>
                <p className="text-gray-700 mb-4">
                  El acceso y uso del Sitio Web implica la aceptación expresa y sin reservas de todos los términos 
                  del presente Aviso Legal. Si no estás de acuerdo con estos términos, te rogamos no utilices este Sitio Web.
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">3. Condiciones de Acceso y Uso</h3>
                <p className="text-gray-700 mb-4">
                  El acceso al Sitio Web es gratuito excepto en lo relativo al coste de conexión a través de la red 
                  de telecomunicaciones suministrada por el proveedor de acceso contratado por los usuarios.
                </p>
                <p className="text-gray-700 mb-4">
                  El usuario se compromete a:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                  <li>Hacer un uso adecuado y lícito del Sitio Web</li>
                  <li>No utilizar el Sitio Web con fines fraudulentos o ilegales</li>
                  <li>No dañar, inutilizar o sobrecargar el Sitio Web</li>
                  <li>No introducir virus o código malicioso</li>
                  <li>No suplantar la identidad de otros usuarios</li>
                  <li>Proporcionar información veraz y actualizada</li>
                </ul>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">4. Propiedad Intelectual e Industrial</h3>
                <p className="text-gray-700 mb-4">
                  Todos los contenidos del Sitio Web (textos, fotografías, gráficos, imágenes, tecnología, software, 
                  links, contenidos, diseño gráfico, código fuente, etc.) son propiedad intelectual de Inmobiliaria 
                  Premium S.L. o de terceros, sin que puedan entenderse cedidos al usuario ninguno de los derechos de 
                  explotación reconocidos por la normativa vigente en materia de propiedad intelectual.
                </p>
                <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
                  <p className="text-gray-700 font-bold mb-2">❌ Queda expresamente prohibido:</p>
                  <ul className="text-sm text-gray-700 space-y-1">
                    <li>• Reproducir, copiar, distribuir o comunicar públicamente los contenidos</li>
                    <li>• Transformar o modificar los contenidos</li>
                    <li>• Utilizar los contenidos para fines comerciales sin autorización</li>
                    <li>• Eliminar o manipular el copyright y demás datos identificativos</li>
                  </ul>
                </div>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">5. Responsabilidad</h3>
                
                <h4 className="font-bold text-gray-800 mt-4 mb-2">5.1. Contenidos</h4>
                <p className="text-gray-700 mb-4">
                  Karpiso S.L. no se hace responsable de:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4 space-y-1">
                  <li>La veracidad, exactitud o actualidad de los contenidos de terceros</li>
                  <li>Daños causados por el acceso o uso del Sitio Web</li>
                  <li>Virus informáticos o elementos lesivos en los contenidos</li>
                  <li>Uso ilícito o incorrecto del Sitio Web por parte de los usuarios</li>
                </ul>

                <h4 className="font-bold text-gray-800 mt-4 mb-2">5.2. Enlaces</h4>
                <p className="text-gray-700 mb-4">
                  El Sitio Web puede contener enlaces a sitios web de terceros. Karpiso S.L. no asume 
                  ninguna responsabilidad sobre el contenido de dichos sitios web.
                </p>

                <h4 className="font-bold text-gray-800 mt-4 mb-2">5.3. Disponibilidad</h4>
                <p className="text-gray-700 mb-4">
                  No garantizamos la disponibilidad y continuidad del funcionamiento del Sitio Web. Nos reservamos el 
                  derecho a interrumpir, suspender o modificar el Sitio Web en cualquier momento.
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">6. Protección de Datos</h3>
                <p className="text-gray-700 mb-4">
                  El tratamiento de datos personales se rige por nuestra{' '}
                  <button
                    onClick={() => {
                      setShowLegalNotice(false);
                      setShowPrivacyPolicy(true);
                    }}
                    className="text-indigo-600 hover:text-indigo-700 font-semibold underline"
                  >
                    Política de Privacidad
                  </button>
                  , conforme al Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD).
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">7. Cookies</h3>
                <p className="text-gray-700 mb-4">
                  Este Sitio Web utiliza cookies. Para más información, consulta nuestra{' '}
                  <button
                    onClick={() => {
                      setShowLegalNotice(false);
                      setShowCookiePolicy(true);
                    }}
                    className="text-indigo-600 hover:text-indigo-700 font-semibold underline"
                  >
                    Política de Cookies
                  </button>.
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">8. Legislación Aplicable y Jurisdicción</h3>
                <p className="text-gray-700 mb-4">
                  Las presentes condiciones se rigen por la legislación española vigente.
                </p>
                <p className="text-gray-700 mb-4">
                  Para la resolución de cualquier conflicto derivado del acceso o uso del Sitio Web, las partes se 
                  someten a los Juzgados y Tribunales del domicilio del usuario consumidor o, en su defecto, a los 
                  de Barcelona capital.
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">9. Nulidad Parcial</h3>
                <p className="text-gray-700 mb-4">
                  Si cualquier cláusula del presente Aviso Legal fuera declarada nula, las demás cláusulas seguirán 
                  vigentes y se interpretarán teniendo en cuenta la voluntad de las partes y la finalidad misma de 
                  las presentes condiciones.
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">10. Modificaciones</h3>
                <p className="text-gray-700 mb-4">
                  Karpiso S.L. se reserva el derecho a modificar el presente Aviso Legal en cualquier 
                  momento. Los usuarios serán informados de dichas modificaciones mediante aviso en el Sitio Web.
                </p>

                <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3">11. Contacto</h3>
                <p className="text-gray-700 mb-4">
                  Para cualquier cuestión relacionada con este Aviso Legal, puedes contactarnos:
                </p>
                <div className="bg-gray-100 p-4 rounded-lg">
                  <p className="text-gray-700"><strong>Email:</strong>  karpiso2025@gmail.com</p>
                  <p className="text-gray-700"><strong>Teléfono:</strong> +34 619 162 617</p>
                  <p className="text-gray-700"><strong>Dirección:</strong> Calle Joaquin Turina, 31 Bis local, Madrid</p>
                </div>

                <div className="bg-indigo-50 border border-indigo-200 p-4 rounded-lg mt-6">
                  <p className="text-sm text-gray-700">
                    <strong>Fecha de última actualización:</strong> Diciembre 2025
                  </p>
                  <p className="text-sm text-gray-700 mt-2">
                    Al utilizar este sitio web, aceptas haber leído y estar de acuerdo con este Aviso Legal.
                  </p>
                </div>
              </div>
            </div>

            <div className="border-t px-6 py-4 bg-gray-50 rounded-b-xl">
              <button
                onClick={() => setShowLegalNotice(false)}
                className="w-full px-6 py-2 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700 transition"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}